import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div id="footer" className="app-footer">
      &copy; {currentYear} Plant People Development Jobsite Maco All Right Reserved
    </div>
  );
}

export default Footer;